module.exports = __webpack_public_path__ + "img/whats-new-18_en.6173103.jpg";